import * as tslib_1 from "tslib";
export class FromAddressValueService {
    static setAddressVal(adcode, format) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const value = [];
            if (!format) {
                format = 'pp-cc-aa';
            }
            const type = format.split('-').length;
            // const mod = await import(/* webpackChunkName: "pca" */'../components/shared/pca-selector/typings/pca');
            const mod = yield import(/* webpackChunkName: "pca" */ '../../../../common/src/pca/pca.min');
            mod.default.forEach((p) => {
                // 找到对应是省
                if (p.adcode === adcode) {
                    value.push(FromAddressValueService.initVal(p));
                    return;
                }
                if (p.districts.length > 0) {
                    p.districts.forEach((c) => {
                        // 匹配到省
                        if (c.adcode === adcode) {
                            value.push(FromAddressValueService.initVal(p));
                            value.push(FromAddressValueService.initVal(c));
                            return;
                        }
                        if (c.districts.length > 0) {
                            c.districts.forEach((a) => {
                                // 匹配到市
                                if (a.adcode === adcode) {
                                    value.push(FromAddressValueService.initVal(p));
                                    value.push(FromAddressValueService.initVal(c));
                                    value.push(FromAddressValueService.initVal(a));
                                    return;
                                }
                            });
                        }
                    });
                }
            });
            const pcaDate = {
                provinceName: '',
                provinceAdcode: '',
                cityName: '',
                cityAdcode: '',
                districtName: '',
                districtAdcode: ''
            };
            value.forEach((pcaItem) => {
                if (pcaItem.level === 'province') {
                    pcaDate.provinceName = pcaItem.name;
                    pcaDate.provinceAdcode = pcaItem.adcode;
                }
                if (pcaItem.level === 'city' && type >= 2) {
                    pcaDate.cityName = pcaItem.name;
                    pcaDate.cityAdcode = pcaItem.adcode;
                }
                if (pcaItem.level === "district" && type >= 3) {
                    pcaDate.districtName = pcaItem.name;
                    pcaDate.districtAdcode = pcaItem.adcode;
                }
            });
            return pcaDate;
        });
    }
    ;
    static initVal(pcaItem) {
        const { adcode, center, level, name } = pcaItem;
        return {
            adcode,
            center,
            level,
            name
        };
    }
}
